<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
    <h3 class="text-center" style="margin-bottom:0"> Subir Archivo Excel de Estudiantes </h3>
    <p class="text-primary text-center" style="margin-top:0"> <small> Seleccione el archivo excel de estudiantes, no cambie el formato pre establecido del documento. </small> </p>
    <hr style="margin-top:0">

    <a :href="excel" download> <span class="glyphicon glyphicon-arrow-down"></span> Descargar formato de ejemplo</a>

    <ExcelIns />
  </div>
</template>

<script>
import ExcelIns from '@/components/AExcelInscribirPrograma'

export default {
  data(){
    return{
      excel: 'img/inscripciones.xlsx'
    }
  },
  components:{ ExcelIns },
}
</script>
